import React from "react";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { useCallTracker } from "@/components/CallTracker";

export function ContactButtons({ name, mobile, product, testPrefix = "contact", track }) {
  const { trackCall } = useCallTracker();
  if (!mobile) return null;
  return (
    <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
      <Button size="icon" variant="ghost" className="h-9 w-9 text-emerald-600" asChild data-testid={`${testPrefix}-call-btn`}>
        <a href={`tel:${mobile}`} title="Call" onClick={() => track && trackCall({ ...track, name, mobile })}><Phone className="h-4 w-4" /></a>
      </Button>
      <WhatsAppButton lead={{ name, mobile, product }} className="h-9 w-9 text-green-600" testId={`${testPrefix}-whatsapp-btn`} />
    </div>
  );
}
